module.exports = __webpack_public_path__ + "a1f3e1a3a0ccbb9084d037af28985643.svg";